module.exports = __webpack_public_path__ + "static/img/SmileAnimation_bloodorangegrapefruit.ca60516.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_bloodorangegrapefruit.gif
// module id = 83OG
// module chunks = 0